import { Link } from "react-router-dom";
import BlogPostLayout from "./BlogPostLayout";
import { getPostBySlug } from "../../lib/blog";

export default function CalendrierTonteTaille() {
  const post = getPostBySlug("calendrier-tonte-taille-saisonniere");
  return (
    <BlogPostLayout post={post}>
      <p>
        Un beau jardin, c'est avant tout une question de <strong>bon timing</strong>.
        Tondre trop tôt, tailler au mauvais moment ou laisser pousser l'herbe en
        plein été peut abîmer votre pelouse et fragiliser vos arbustes. Voici
        notre calendrier mois par mois — adapté au <strong>climat de la Creuse</strong>,
        à mi-chemin entre continental et océanique.
      </p>

      <h2>Janvier — Février : le repos végétatif</h2>
      <ul>
        <li>
          <strong>Tonte :</strong> aucune. La pelouse est en dormance.
        </li>
        <li>
          <strong>Taille :</strong> c'est la <strong>meilleure période pour
          tailler les arbres fruitiers à pépins</strong> (pommiers, poiriers).
          Profitez d'un jour sec et hors gel.
        </li>
        <li>
          <strong>À faire :</strong> entretien du matériel, affûtage des lames,
          révision de la tondeuse, planification des semis.
        </li>
      </ul>

      <h2>Mars : la reprise</h2>
      <ul>
        <li>
          <strong>Tonte :</strong> 1ʳᵉ tonte de l'année dès que l'herbe atteint
          7-8 cm. Réglez la coupe haute (5 cm).
        </li>
        <li>
          <strong>Taille :</strong> rosiers, arbustes à floraison estivale
          (buddleia, hibiscus), graminées.
        </li>
        <li>
          <strong>À faire :</strong> scarification de la pelouse, premier
          apport d'engrais organique.
        </li>
      </ul>

      <h2>Avril — Mai : pleine croissance</h2>
      <ul>
        <li>
          <strong>Tonte :</strong> <strong>tous les 7 à 10 jours</strong>. Hauteur
          de coupe 4-5 cm. Ne tondez jamais plus d'un tiers de la hauteur d'un
          coup.
        </li>
        <li>
          <strong>Taille :</strong> haies de feuillus (charme, hêtre). Évitez la
          taille des haies entre <strong>mi-mars et fin juillet</strong> si elles
          abritent des nids d'oiseaux (recommandation LPO).
        </li>
        <li>
          <strong>À faire :</strong> traitement préventif des nuisibles,
          surveillance des nids primaires de frelons asiatiques.
        </li>
      </ul>

      <div className="callout">
        <strong>Bon à savoir</strong>
        En mai, ne tondez pas pendant{" "}
        <strong>« Mai sans tondeuse »</strong> : laisser pousser quelques zones
        favorise les pollinisateurs et la biodiversité de votre jardin.
      </div>

      <h2>Juin — Juillet : gestion des canicules</h2>
      <ul>
        <li>
          <strong>Tonte :</strong> espacez à <strong>tous les 10-14 jours</strong>{" "}
          et <strong>remontez la hauteur à 6-7 cm</strong>. Une herbe haute résiste
          mieux à la sécheresse et conserve l'humidité du sol.
        </li>
        <li>
          <strong>Taille :</strong> arbustes à floraison printanière une fois
          défleuris (lilas, forsythia, weigela). Premier passage sur les haies.
        </li>
        <li>
          <strong>À faire :</strong> arrosage tôt le matin ou tard le soir,
          paillage des massifs, désherbage régulier.
        </li>
      </ul>

      <h2>Août : ralentissement</h2>
      <ul>
        <li>
          <strong>Tonte :</strong> uniquement si l'herbe pousse. En cas de
          sécheresse, <strong>ne tondez pas</strong> : vous brûleriez la pelouse.
        </li>
        <li>
          <strong>Taille :</strong> entretien léger des haies fleuries.
        </li>
        <li>
          <strong>À faire :</strong> surveillance des nids de frelons et guêpes
          (pic d'activité), arrosage des jeunes plantations.
        </li>
      </ul>

      <h2>Septembre — Octobre : préparation à l'hiver</h2>
      <ul>
        <li>
          <strong>Tonte :</strong> reprenez un rythme <strong>tous les 10
          jours</strong>, hauteur 5 cm. Dernière tonte fin octobre.
        </li>
        <li>
          <strong>Taille :</strong> deuxième passage sur les haies, taille
          d'automne des arbustes caducs.
        </li>
        <li>
          <strong>À faire :</strong> regarnissage des zones dégarnies de
          pelouse, ramassage des feuilles, plantation des arbustes en racines
          nues.
        </li>
      </ul>

      <h2>Novembre — Décembre : on protège</h2>
      <ul>
        <li>
          <strong>Tonte :</strong> dernière tonte « basse » (4 cm) pour éviter
          que les feuilles n'asphyxient le gazon.
        </li>
        <li>
          <strong>Taille :</strong> élagage des grands arbres (hors gel),
          taille d'éclaircie des fruitiers à noyau (cerisier, prunier) — à faire
          en lune descendante de préférence.
        </li>
        <li>
          <strong>À faire :</strong> paillage hivernal, protection des plantes
          fragiles, nettoyage et remisage du matériel.
        </li>
      </ul>

      <h2>Récap visuel : la règle des 1/3</h2>
      <div className="callout">
        <strong>Règle d'or de la tonte</strong>
        Ne coupez <strong>jamais plus d'un tiers</strong> de la hauteur de
        l'herbe en une seule passe. Une pelouse de 12 cm doit être ramenée à 8
        cm, puis à 5-6 cm la fois suivante. Cela évite le jaunissement et
        renforce les racines.
      </div>

      <h2>Vous préférez déléguer ?</h2>
      <p>
        Confier son jardin à un paysagiste local en Creuse, c'est gagner du
        temps et profiter du <strong>crédit d'impôt 50 %</strong> sur
        l'entretien courant. Découvrez nos formules d'
        <Link to="/entretien-jardin-creuse">entretien jardin en Creuse</Link>{" "}
        ou nos services d'<Link to="/elagage-creuse">élagage</Link>. Et pour ne rien manquer, lisez
        aussi notre article sur le{" "}
        <Link to="/conseils/credit-impot-50-entretien-jardin">
          crédit d'impôt 50 %
        </Link>
        .
      </p>
    </BlogPostLayout>
  );
}
